import { createContext, useContext, Dispatch, SetStateAction } from 'react';

export interface AppContextData {
  appName: string;
  setAppName: Dispatch<SetStateAction<string>>;
  showTopbar: boolean;
  setShowTopbar: Dispatch<SetStateAction<boolean>>;
  showSidebar: boolean;
  setShowSidebar: Dispatch<SetStateAction<boolean>>;
  showFooter: boolean;
  selectedPipeline: string;
  setSelectedPipeline: Dispatch<SetStateAction<string>>;
  selectedChat: string;
  setSelectedChat: Dispatch<SetStateAction<string>>;
}

export const AppContext = createContext<AppContextData | null>(null);

export function useAppContext(): AppContextData {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used within AppContext.Provider');
  return ctx;
}
